import { Component, OnInit, Inject } from '@angular/core';
import { FornecedorEstruturaService } from 'src/app/services/fornecedor-estrutura.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { GlobalService } from 'src/app/services/global.service';
import { VariavelSimulacao } from 'src/app/models/variavel-simulacao';
import { SimulacaoEstrutura } from 'src/app/models/simulacao-estrutura';
import { FornecedorEstruturaItem } from 'src/app/models/fornecedor-estrutura-item';
import { PremissasService } from 'src/app/services/premissas.service';

@Component({
  selector: 'app-simulacao-estrutura-modal',
  templateUrl: './simulacao-estrutura-modal.component.html',
  styleUrls: ['./simulacao-estrutura-modal.component.scss']
})
export class SimulacaoEstruturaModalComponent implements OnInit {
  variaveisSimulacao: VariavelSimulacao[] = [];
  simulacaoEstrutura: SimulacaoEstrutura;
  itens: FornecedorEstruturaItem[] = [];
  public config: PerfectScrollbarConfigInterface = {};
  idFornecedor;
  telhado;
  orientacao;

  constructor(
    private fornecedorEstrtuturaService: FornecedorEstruturaService,
    private dialogRef: MatDialogRef<SimulacaoEstruturaModalComponent>,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private premissasService: PremissasService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.simulacaoEstrutura = new SimulacaoEstrutura();

    this.idFornecedor = data.idFornecedor;
    this.telhado = data.telhado;
    this.orientacao = data.orientacao;
  }

  ngOnInit(): void {
    this.buscarVariaveis();
  }

  buscarVariaveis() {
    this.carregandoService.mostra('buscarVariaveis');
    this.fornecedorEstrtuturaService.consultarVariaveisParaSimular(this.idFornecedor, this.telhado, this.orientacao).subscribe(
      resp => {
        this.variaveisSimulacao = resp;
        this.carregandoService.esconde('buscarVariaveis');
      },
      err => {
        this.carregandoService.esconde('buscarVariaveis');
        this.notificacaoService.erro(err);
      }
    );
  }

  simular() {
    this.carregandoService.mostra('simular');

    this.simulacaoEstrutura.idFornecedor = this.idFornecedor;
    this.simulacaoEstrutura.telhado = this.telhado;
    this.simulacaoEstrutura.orientacao = this.orientacao;
    this.simulacaoEstrutura.variaveis = this.variaveisSimulacao;

    this.fornecedorEstrtuturaService.simularEstrutura(this.simulacaoEstrutura).subscribe(
      (resp: FornecedorEstruturaItem[]) => {
        this.itens = resp;
        this.carregandoService.esconde('simular');
      },
      err => {
        this.carregandoService.esconde('simular');
        this.notificacaoService.erro(err);
      }
    );
  }

  fechar() {
    this.dialogRef.close();
  }

}
